// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoBubble_tooltip__Ye892 {
  background-color: white;
  color: dimgray;
  padding: 1rem;
  border-radius: 4px;
  box-shadow: 0px 1px 3px dimgray;
}

.InfoBubble_triangle__XnePy {
  margin: auto;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 1rem 0 0 1rem;
  border-color: transparent transparent transparent white;
  box-shadow: -2px 2px 1px gray;
  transform-origin: -2px 2px;
  transform: rotate(-45deg);
}

.InfoBubble_component-wrapper__zWR5s {
  position: relative;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: inline-flex;
  align-items: center;
}
.InfoBubble_component-wrapper__zWR5s .InfoBubble_tooltip-wrapper__gDqSz {
  position: absolute;
  display: none;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%);
}
.InfoBubble_component-wrapper__zWR5s:hover {
  color: #454545;
}
.InfoBubble_component-wrapper__zWR5s:hover .InfoBubble_tooltip-wrapper__gDqSz {
  display: block;
}

.InfoBubble_battery__yBl40 {
  font-size: 1.25rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/InfoBubble.module.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,cAAA;EAEA,aAAA;EACA,kBAAA;EACA,+BAAA;AAAF;;AAIA;EAEE,YAAA;EAIA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,2BAAA;EACA,uDAAA;EACA,6BAAA;EAIA,0BAAA;EACA,yBAAA;AARF;;AAWA;EACE,kBAAA;EAEA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;AATF;AAWE;EACE,kBAAA;EAEA,aAAA;EAGA,YAAA;EAEA,SAAA;EAEA,0BAAA;AAdJ;AAkBE;EACE,cAAA;AAhBJ;AAkBI;EACE,cAAA;AAhBN;;AAqBA;EACE,kBAAA;AAlBF","sourcesContent":[".tooltip {\n  background-color: white;\n  color: dimgray;\n  padding: 1rem;\n  border-radius: 4px;\n  box-shadow: 0px 1px 3px dimgray;\n}\n\n.triangle {\n  margin: auto;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  border-width: 1rem 0 0 1rem;\n  border-color: transparent transparent transparent white;\n  box-shadow: -2px 2px 1px gray;\n  transform-origin: -2px 2px;\n  transform: rotate(-45deg);\n}\n\n.component-wrapper {\n  position: relative;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: inline-flex;\n  align-items: center;\n}\n.component-wrapper .tooltip-wrapper {\n  position: absolute;\n  display: none;\n  bottom: 100%;\n  left: 50%;\n  transform: translate(-50%);\n}\n.component-wrapper:hover {\n  color: #454545;\n}\n.component-wrapper:hover .tooltip-wrapper {\n  display: block;\n}\n\n.battery {\n  font-size: 1.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `InfoBubble_tooltip__Ye892`,
	"triangle": `InfoBubble_triangle__XnePy`,
	"component-wrapper": `InfoBubble_component-wrapper__zWR5s`,
	"tooltip-wrapper": `InfoBubble_tooltip-wrapper__gDqSz`,
	"battery": `InfoBubble_battery__yBl40`
};
export default ___CSS_LOADER_EXPORT___;
